import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global_menu.css */
  div {
    white-space: nowrap;
  }
  div div.link {
    text-decoration: none;
    padding: 5px 20px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    transition: 0.5s;
    font-size: 0.8rem;
    cursor: pointer;
  }
  div div.link:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/panels.css */
  details {
    overflow: hidden;
  }
  details:first-child {
    border: var(--border);
    border-radius: var(--border-radius) var(--border-radius) 0 0;
  }
  details summary {
    display: flex;
    z-index: 1;
    position: relative;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px;
    background-color: red; //var(--summary-bg-color);
    transition-property: color, background-color;
  }
  details summary:focus {
    outline: none;
    color: var(--primary);
  }
  details[open] > summary {
    background-color: rgb(19, 23, 28);
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/referrals_menu.css */
  #referrals_menu {
    display: flex;
    position: relative;
  }
  #referrals_menu details {
    border-radius: 0;
  }
  #referrals_menu .dropdown * {
    display: flex;
  }
  #referrals_menu .dropdown summary {
    list-style: none;
    list-style-type: none;
    cursor: pointer;
    color: var(--dropdown-color);
    position: relative;
    background: hsla(0, 0%, 100%, 0.1);
    padding: 6px 10px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
  }
  #referrals_menu .dropdown summary:hover {
    background: hsla(0, 0%, 100%, 0.2);
  }
  #referrals_menu .dropdown > summary::-webkit-details-marker {
    display: none;
  }
  #referrals_menu .dropdown div.menu {
    position: absolute;
    margin: 12px 0 0 0;
    padding: 20px 0;
    width: var(--hamburger-dropdown-width);
    right: auto;
    left: 0;
    box-sizing: border-box;
    z-index: 2;
    background: hsla(214, 18%, 22%, 0.5);
    border-radius: 5px;
    list-style: none;
    -webkit-backdrop-filter: var(--dropdown-backdrop-filter);
    backdrop-filter: var(--dropdown-backdrop-filter);
    display: flex;
    flex-direction: column;
    cursor: default;
    justify-content: flex-start;
    -webkit-box-shadow: 0 0 45px 20px hsla(0, 0%, 0%, 0.1);
    box-shadow: 0 0 45px 20px hsla(0, 0%, 0%, 0.1);
    max-width: 325px;
  }
  #referrals_menu .dropdown > summary::before {
    display: none;
  }
  #referrals_menu .dropdown[open] > summary::before {
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    left: -100%;
    bottom: 0;
    z-index: 0;
    outline: 0;
    width: calc(100% + 100% + 30px);
    height: 100vh;
    cursor: default !important;
  }
  #referrals_menu div.your_referral_link,
  #referrals_menu div.rewards_earned,
  #referrals_menu div.total_referees,
  #referrals_menu div.links {
    padding: 0 20px 5px 20px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    margin: 0 0 5px 0;
    align-items: center;
  }
  #referrals_menu div.your_referral_link {
    border-bottom: 0;
    margin: 0 0 5px 0;
    flex-direction: column;
    align-items: flex-start;
  }
  #referrals_menu div.links {
    border-bottom: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    flex-direction: column;
    align-items: flex-start;
  }
  #referrals_menu div.links div.link {
    padding: 0;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    display: inline;
    width: fit-content;
    padding: 5px 0 0 0;
    margin: 5px 0 0 16px;
    position: relative;
  }
  #referrals_menu div.links div.link:before {
    background: url('http://yolo.tino.me/app_v3/resources/images/icons/external_link_icon.svg') left center / 10px auto
      no-repeat;
    position: absolute;
    top: 50%;
    left: -16px;
    transform: translateY(-50%);
    width: 10px;
    height: 10px;
    z-index: 1;
    content: '';
  }
  #referrals_menu div.links div.link:hover {
    border-bottom: 1px dotted transparent;
    background: transparent;
  }
  #referrals_menu div.your_referral_link div,
  #referrals_menu div.rewards_earned div,
  #referrals_menu div.total_referees div {
    font-size: 0.75rem;
    font-weight: 600;
  }
  #referrals_menu div.your_referral_link .link {
    font-size: 0.85rem;
    font-weight: 200;
    background: hsla(0, 0%, 0%, 0.3);
    border-radius: 6px;
    padding: 8px 12px;
    margin: 5px 0 0 0;
    position: relative;
  }

  #referrals_menu div.rewards_earned .value,
  #referrals_menu div.total_referees .value {
    margin: 0 0 0 5px;
    background: hsla(0, 0%, 0%, 0.2);
    border-radius: 6px;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.9rem;
  }
`

const developerCSS = css`
  #referrals_menu div.your_referral_link .link span {
    white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 20px;
  }
`

export const ReferralsDropDownCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
export const CopyIcon = styled(IconLib).attrs({ dimension: '16px' })`
  position: absolute;
  right: 10px;
  width: 12px;
  height: 12px;
`
